export default __webpack_public_path__ + "static/media/users.3322f808.svg";